'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = professionalDetails;
exports.updateBlock = updateBlock;
exports.updateField = updateField;
exports.addBlock = addBlock;
exports.sort = sort;
exports.copyBlock = copyBlock;
exports.deleteBlock = deleteBlock;
exports.clean = clean;

var _reactSortableHoc = require('react-sortable-hoc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATEBLOCK = 'professionalDetails/UPDATEBLOCK';UPDATEFIELD;
var ADDBLOCK = 'professionalDetails/ADDBLOCK';
var UPDATEFIELD = 'professionalDetails/UPDATEFIELD';
var SORT = 'professionalDetails/SORT';
var DELETE = 'professionalDetails/DELETE';
var COPY = 'professionalDetails/COPY';
var CLEAN = 'professionalDetails/CLEAN';

var initialState = [];

function professionalDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATEBLOCK:
      //var {state} = state;
      state[action.index].company = action.company;
      state[action.index].designation = action.designation;
      state[action.index].location = action.location;
      state[action.index].short_title = action.short_title;
      state[action.index].title = action.title;
      state[action.index].date_from = action.date_from;
      state[action.index].date_to = action.date_to;
      state[action.index].description = action.description;
      state[action.index].chart_data = action.chart_data;
      state[action.index].chart_type = action.chart_type;
      return {
        state: state
      };
    case ADDBLOCK:
      var new_state = state;
      var object = {};
      object['company'] = action.company;
      object['designation'] = action.designation;
      object['location'] = action.location;
      object['short_title'] = action.short_title;
      object['title'] = action.title;
      object['date_from'] = action.date_from;
      object['date_to'] = action.date_to;
      object['description'] = action.description;
      object['chart_data'] = action.chart_data;
      object['chart_type'] = action.chart_type;
      object['id'] = action.id;
      new_state.push(object);
      return new_state;
    case UPDATEFIELD:
      var field = action.field;
      var object = {};
      object[field] = action.data;
      return [].concat((0, _toConsumableArray3.default)(state.slice(0, action.index)), [
      // Copy the object before mutating
      (0, _assign2.default)({}, state[action.index], object)], (0, _toConsumableArray3.default)(state.slice(action.index + 1)));
    case SORT:
      var sort_state = (0, _reactSortableHoc.arrayMove)(state, action.oldIndex, action.newIndex);
      return sort_state;
    case COPY:
      var object = state[action.index];
      object['id'] = action.new_id;
      var copy_state = state.concat(object);
      // var copy_state = state.concat(state[action.index]);
      // copy_state = arrayMove(copy_state, copy_state.length - 1, action.index + 1)
      return copy_state;
    case DELETE:
      var delete_state = state;
      delete_state.splice(action.index, 1);
      return delete_state;
    case CLEAN:
      return [];
    default:
      return state;
  }
}

function updateBlock(data, index) {
  return {
    type: UPDATEBLOCK,
    id: index,
    company: data.company,
    designation: data.designation,
    location: data.location,
    short_title: data.short_title,
    title: data.title,
    date_from: data.date_from,
    date_to: data.date_to,
    description: data.description,
    chart_data: data.chart_data,
    chart_type: data.chart_type
  };
}

function updateField(data, index, field) {
  return {
    type: UPDATEFIELD,
    index: index,
    data: data,
    field: field
  };
}

function addBlock(data) {
  return {
    type: ADDBLOCK,
    company: data.company,
    designation: data.designation,
    location: data.location,
    short_title: data.short_title,
    title: data.title,
    date_from: data.date_from,
    date_to: data.date_to,
    description: data.description,
    chart_data: data.chart_data,
    chart_type: data.chart_type,
    id: data.id
  };
}

function sort(oldIndex, newIndex) {
  return {
    type: SORT,
    oldIndex: oldIndex,
    newIndex: newIndex
  };
}

function copyBlock(index, new_id) {
  return {
    type: COPY,
    index: index,
    id: new_id
  };
}

function deleteBlock(index) {
  return {
    type: DELETE,
    index: index
  };
}

function clean() {
  return {
    type: CLEAN
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/professionalDetails.js
// module id = 296
// module chunks = 0